import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress console warnings from form scripts
const originalWarn = console.warn;
const originalError = console.error;

console.warn = function(...args) {
  const message = args.join(' ');
  // Suppress warnings from form scripts
  if (
    message.includes('locale code: en-US') ||
    message.includes('Deprecated API') ||
    message.includes('Permissions policy violation') ||
    message.includes('CPso3y6f.js') ||
    message.includes('DTQbshdm.js') ||
    message.includes('Dmdp8tGv.js')
  ) {
    return; // Suppress these warnings
  }
  originalWarn.apply(console, args);
};

console.error = function(...args) {
  const message = args.join(' ');
  // Suppress errors from form scripts
  if (
    message.includes('leadconnectorhq.com') ||
    message.includes('form-survey-event') ||
    message.includes('FetchError') ||
    message.includes('Failed to fetch') ||
    message.includes('includes is not a function') ||
    message.includes('CPso3y6f.js') ||
    message.includes('DTQbshdm.js') ||
    message.includes('Dmdp8tGv.js') ||
    message.includes('Permissions policy violation')
  ) {
    return; // Suppress these errors
  }
  originalError.apply(console, args);
};

// Global error handlers to suppress errors from third-party iframes (like form widgets)
// This prevents Google AdWords from seeing console errors and flagging the page
window.addEventListener('error', (event) => {
  // Suppress errors from leadconnectorhq.com (form backend) and form scripts
  if (
    event.message &&
    (event.message.includes('leadconnectorhq.com') ||
      event.message.includes('form-survey-event') ||
      event.message.includes('FetchError') ||
      event.message.includes('Failed to fetch') ||
      event.message.includes('includes is not a function') ||
      event.message.includes('CPso3y6f.js') ||
      event.message.includes('DTQbshdm.js') ||
      event.message.includes('Dmdp8tGv.js') ||
      event.filename?.includes('form_embed.js') ||
      event.filename?.includes('CPso3y6f.js') ||
      event.filename?.includes('DTQbshdm.js'))
  ) {
    event.preventDefault();
    return false;
  }
}, true);

// Handle unhandled promise rejections (common with failed API calls from iframes)
window.addEventListener('unhandledrejection', (event) => {
  // Suppress promise rejections from form backend
  if (
    event.reason &&
    (event.reason.message?.includes('leadconnectorhq.com') ||
      event.reason.message?.includes('form-survey-event') ||
      event.reason.message?.includes('FetchError') ||
      event.reason.message?.includes('Failed to fetch') ||
      event.reason.message?.includes('includes is not a function'))
  ) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
